// leaf-town - world art: palettes, terrain and the parallax backdrops of the five worlds
(function () {
  'use strict';
  const G = window.G, T = 16, W = G.W, H = G.H, K = G.COL.ink;
  const hash = G.hash;

  const TH = (G.THEME = {
    1: {
      name: 'THE SOURCE TREE', path: '~/src', time: '02:51', music: 'w1', ambient: '#aab2dc',
      base: '#2b2440', dark: '#1a152b', lite: '#3d3259', cap: '#5fb86f', capHi: '#a6e88f', capLo: '#2f7a52',
      code: ['#4b3f6b', '#5a4a82', '#3f5a6b', '#6b4a5f'],
      plat: '#8a5f3c', platHi: '#c9955c', platLo: '#553622', accent: '#ffd97a', fx: '#a6e88f', glow: '#ffe9a8',
      liq: '#58f0c8', liqHi: '#d2fff2', liqLo: '#167a78',
    },
    2: {
      name: 'DEPENDENCY DEPTHS', path: '~/node_modules', time: '03:34', music: 'w2', ambient: '#b3a0a6',
      base: '#b98349', dark: '#7a4f2e', lite: '#e2b475', cap: '#f0cd92', capHi: '#fff0cf', capLo: '#8f6238',
      code: ['#a06f3c', '#8f6238', '#cf9d5f', '#a06f3c'],
      plat: '#8f6238', platHi: '#e2b475', platLo: '#4e3220', accent: '#ff8fb0', fx: '#f0cd92', glow: '#ffd9a0',
      liq: '#c46ad8', liqHi: '#f6d0ff', liqLo: '#5a2470',
    },
    3: {
      name: 'THE HEAP', path: '/proc/heap', time: '04:20', music: 'w3', ambient: '#5f6cb0',
      base: '#232a5c', dark: '#151a40', lite: '#33407f', cap: '#9cf7e0', capHi: '#eafff9', capLo: '#2b8f96',
      code: ['#2e3976', '#3a4a9a', '#2b5f8a', '#2e3976'],
      plat: '#3fbfae', platHi: '#d2fff2', platLo: '#1b5f6e', accent: '#58f0c8', fx: '#9cf7e0', glow: '#7cf5d4',
      liq: '#58f0c8', liqHi: '#e6fff8', liqLo: '#127a80',
    },
    4: {
      name: 'THREAD TOWER', path: '/dev/threads', time: '05:12', music: 'w4', ambient: '#e6cfc4',
      base: '#a8793a', dark: '#5f3d1e', lite: '#dcae5e', cap: '#f3d58a', capHi: '#fff4c9', capLo: '#6b4520',
      code: ['#8f6430', '#8f6430', '#c2924a', '#8f6430'],
      plat: '#7a4a5a', platHi: '#d98a8a', platLo: '#3c1f33', accent: '#ff7a59', fx: '#f3d58a', glow: '#ffe2a0',
      liq: '#ff7a59', liqHi: '#ffe0c0', liqLo: '#8a2a2a',
    },
    5: {
      name: 'PRODUCTION', path: '/var/prod', time: '05:51', music: 'w5', ambient: '#b48a8a',
      base: '#2c2f3c', dark: '#181a22', lite: '#474b5e', cap: '#7d8296', capHi: '#c5cbdb', capLo: '#14151c',
      code: ['#22242f', '#383c4c', '#22242f', '#383c4c'],
      plat: '#5c6378', platHi: '#c5cbdb', platLo: '#23252f', accent: '#ff4b3e', fx: '#ffb347', glow: '#ff7a3a',
      liq: '#ff6a2a', liqHi: '#ffe27a', liqLo: '#8a1a10',
    },
  });

  // ---------- terrain ----------
  // n = neighbours that are also solid: {u,d,l,r}
  G.drawSolid = (g, w, px, py, tx, ty, n) => {
    const th = TH[w], h = hash(tx, ty, w);
    g.fillStyle = th.base; g.fillRect(px, py, T, T);
    if (w === 1) {
      // soil made of half-remembered lines of code
      for (let r = 0; r < 3; r++) {
        const hh = hash(tx * 3 + r, ty, 7);
        if (hh < 0.72) {
          const len = 2 + Math.floor(hash(tx, ty * 3 + r, 9) * 8), off = 1 + Math.floor(hash(tx + r, ty, 11) * (13 - len));
          g.fillStyle = th.code[Math.floor(hh * 9) % 4]; g.fillRect(px + off, py + 5 + r * 4, len, 1);
          if (hh < 0.2) g.fillRect(px + off + len + 1, py + 5 + r * 4, 2, 1);
        }
      }
    } else if (w === 2) {
      // every block is a parcel
      const tint = h < 0.3 ? '#ad7840' : h > 0.8 ? '#c48c50' : th.base;
      g.fillStyle = tint; g.fillRect(px, py, T, T);
      g.fillStyle = th.lite; g.fillRect(px, py, T, 1); g.fillRect(px, py, 1, T);
      g.fillStyle = th.dark; g.fillRect(px, py + 15, T, 1); g.fillRect(px + 15, py, 1, T);
      const v = Math.floor(hash(tx, ty, 21) * 6);
      if (v === 0) { g.fillStyle = '#e9d2a6'; g.fillRect(px + 7, py + 1, 3, 14); }
      else if (v === 1) { g.fillStyle = th.dark; g.fillRect(px + 1, py + 5, 14, 1); g.fillRect(px + 1, py + 10, 14, 1); }
      else if (v === 2) { g.fillStyle = '#f4ede0'; g.fillRect(px + 8, py + 8, 5, 4); g.fillStyle = th.dark; g.fillRect(px + 9, py + 9, 3, 1); g.fillRect(px + 9, py + 11, 2, 1); }
      else if (v === 3) { g.fillStyle = th.dark; for (let i = 0; i < 5; i++) g.fillRect(px + 3 + i * 2, py + 9, 1, 4 - (i % 2)); }
      else if (v === 4) { g.fillStyle = '#e9d2a6'; g.fillRect(px + 1, py + 7, 14, 2); }
    } else if (w === 3) {
      // memory cells
      g.fillStyle = th.lite; g.fillRect(px, py, T, 1); g.fillRect(px, py, 1, T);
      g.fillStyle = th.dark; g.fillRect(px, py + 15, T, 1); g.fillRect(px + 15, py, 1, T);
      if (h < 0.22) { g.fillStyle = '#2b6f96'; g.fillRect(px + 4, py + 5, 3, 5); g.fillRect(px + 9, py + 5, 3, 5); g.fillStyle = th.base; g.fillRect(px + 5, py + 6, 1, 3); g.fillRect(px + 10, py + 6, 1, 1); }
      else if (h < 0.34) { g.fillStyle = '#3a4a9a'; g.fillRect(px + 6, py + 7, 4, 2); }
      else if (h > 0.9) { g.fillStyle = '#58f0c8'; g.fillRect(px + 7, py + 7, 2, 2); }
    } else if (w === 4) {
      // brass brickwork
      g.fillStyle = th.dark;
      g.fillRect(px, py + 7, T, 1); g.fillRect(px, py + 15, T, 1);
      g.fillRect(px + 7, py, 1, 7); g.fillRect(px + 15, py + 8, 1, 7);
      g.fillStyle = th.lite;
      g.fillRect(px, py, 7, 1); g.fillRect(px + 8, py, 8, 1); g.fillRect(px, py + 8, 15, 1);
      if (h < 0.3) { g.fillStyle = th.capHi; g.fillRect(px + 3, py + 3, 1, 1); g.fillStyle = th.dark; g.fillRect(px + 3, py + 4, 1, 1); }
      if (h > 0.75) { g.fillStyle = '#8f6430'; g.fillRect(px + 9, py + 10, 5, 3); }
    } else {
      // server chassis
      g.fillStyle = th.lite; g.fillRect(px, py, T, 1); g.fillRect(px, py, 1, T);
      g.fillStyle = th.dark; g.fillRect(px, py + 15, T, 1); g.fillRect(px + 15, py, 1, T);
      if (h < 0.5) { g.fillStyle = th.dark; for (let i = 0; i < 3; i++) g.fillRect(px + 3, py + 6 + i * 3, 10, 1); }
      else if (h < 0.7) { g.fillStyle = '#1e2029'; g.fillRect(px + 3, py + 4, 10, 8); g.fillStyle = '#383c4c'; g.fillRect(px + 4, py + 6, 8, 1); g.fillRect(px + 4, py + 9, 8, 1); }
      g.fillStyle = '#5a5f74'; g.fillRect(px + 2, py + 2, 1, 1); g.fillRect(px + 13, py + 13, 1, 1);
    }
    // exposed faces
    if (!n.d) { g.fillStyle = th.dark; g.fillRect(px, py + 14, T, 2); }
    if (!n.l) { g.fillStyle = th.dark; g.fillRect(px, py, 1, T); }
    if (!n.r) { g.fillStyle = th.dark; g.fillRect(px + 15, py, 1, T); }
    if (!n.u) {
      if (w === 1) {
        g.fillStyle = th.capLo; g.fillRect(px, py, T, 4);
        g.fillStyle = th.cap; g.fillRect(px, py, T, 3);
        for (let i = 0; i < T; i++) {
          const d = hash(tx * 16 + i, ty, 5);
          if (d < 0.55) { g.fillStyle = th.capHi; g.fillRect(px + i, py, 1, 1); }
          if (d > 0.62) { g.fillStyle = th.cap; g.fillRect(px + i, py + 3, 1, d > 0.86 ? 3 : 1); }
        }
      } else if (w === 2) {
        g.fillStyle = th.cap; g.fillRect(px, py, T, 2);
        g.fillStyle = th.capHi; for (let i = 0; i < T; i++) if (hash(tx * 16 + i, ty, 5) < 0.4) g.fillRect(px + i, py, 1, 1);
        g.fillStyle = th.capLo; g.fillRect(px, py + 2, T, 1);
      } else if (w === 3) {
        g.fillStyle = th.capHi; g.fillRect(px, py, T, 1);
        g.fillStyle = th.cap; g.fillRect(px, py + 1, T, 1);
        g.fillStyle = th.capLo; g.fillRect(px, py + 2, T, 1);
        for (let i = 0; i < T; i++) if (hash(tx * 16 + i, ty, 5) < 0.2) { g.fillStyle = th.capLo; g.fillRect(px + i, py + 3, 1, 2); }
      } else if (w === 4) {
        g.fillStyle = th.cap; g.fillRect(px, py, T, 2);
        g.fillStyle = th.capHi; g.fillRect(px, py, T, 1);
        g.fillStyle = th.capLo; g.fillRect(px, py + 2, T, 1);
      } else {
        g.fillStyle = th.cap; g.fillRect(px, py, T, 2);
        g.fillStyle = th.capHi; g.fillRect(px, py, T, 1);
        if (hash(tx, ty, 31) < 0.3) for (let i = 0; i < T; i++) { g.fillStyle = ((i + tx * 16) >> 2) & 1 ? '#f2c14e' : '#1b1226'; g.fillRect(px + i, py + 2, 1, 2); }
        else { g.fillStyle = th.capLo; g.fillRect(px, py + 2, T, 1); }
      }
      if (!n.l) g.clearRect(px, py, 1, 1);
      if (!n.r) g.clearRect(px + 15, py, 1, 1);
    }
    if (!n.d) { if (!n.l) g.clearRect(px, py + 15, 1, 1); if (!n.r) g.clearRect(px + 15, py + 15, 1, 1); }
  };
  // little things growing on top of the ground
  G.drawDecor = (g, w, px, py, tx, ty) => {
    const h = hash(tx, ty, 77), th = TH[w];
    if (w === 1) {
      if (h < 0.34) { g.fillStyle = th.cap; const n = 2 + Math.floor(h * 12); for (let i = 0; i < n; i++) { const x = px + 1 + Math.floor(hash(tx, ty, i) * 14), hh = 1 + Math.floor(hash(tx, i, ty) * 4); g.fillRect(x, py + T - hh, 1, hh); } }
      else if (h < 0.42) { g.fillStyle = th.capLo; g.fillRect(px + 7, py + 11, 1, 5); g.fillStyle = '#ffd97a'; g.fillRect(px + 6, py + 9, 3, 3); g.fillStyle = '#fff6d0'; g.fillRect(px + 7, py + 10, 1, 1); }
      else if (h < 0.47) { g.fillStyle = '#e9d9ee'; g.fillRect(px + 5, py + 13, 2, 3); g.fillStyle = '#e0568a'; g.fillRect(px + 3, py + 11, 6, 2); g.fillRect(px + 4, py + 10, 4, 1); g.fillStyle = '#ffc2d8'; g.fillRect(px + 5, py + 11, 1, 1); }
    } else if (w === 2) {
      if (h < 0.1) { g.fillStyle = '#8f6238'; g.fillRect(px + 3, py + 9, 9, 7); g.fillStyle = '#e2b475'; g.fillRect(px + 3, py + 9, 9, 1); g.fillStyle = '#e9d2a6'; g.fillRect(px + 7, py + 9, 2, 7); }
      else if (h < 0.18) { g.fillStyle = '#f4ede0'; g.fillRect(px + 4, py + 14, 6, 2); g.fillStyle = '#c9bfae'; g.fillRect(px + 5, py + 15, 4, 1); }
    } else if (w === 3) {
      if (h < 0.16) { const hh = 4 + Math.floor(h * 50); g.fillStyle = '#2b8f96'; g.fillRect(px + 6, py + T - hh, 3, hh); g.fillStyle = '#9cf7e0'; g.fillRect(px + 6, py + T - hh, 1, hh); g.fillRect(px + 7, py + T - hh - 1, 1, 1); g.fillStyle = '#2b8f96'; g.fillRect(px + 10, py + 13, 2, 3); }
    } else if (w === 4) {
      if (h < 0.1) { g.fillStyle = '#5f3d1e'; g.fillRect(px + 5, py + 10, 6, 6); g.fillStyle = '#f3d58a'; g.fillRect(px + 6, py + 11, 4, 1); g.fillRect(px + 7, py + 8, 2, 2); }
    } else if (h < 0.12) { g.fillStyle = '#1b1226'; g.fillRect(px + 4, py + 12, 8, 4); g.fillStyle = '#ff4b3e'; g.fillRect(px + 6, py + 13, 1, 1); g.fillStyle = '#7fd08a'; g.fillRect(px + 9, py + 13, 1, 1); }
  };
  G.drawOneway = (g, w, px, py, tx, n) => {
    const th = TH[w];
    g.fillStyle = th.platLo; g.fillRect(px, py, T, 5);
    g.fillStyle = th.plat; g.fillRect(px, py, T, 3);
    g.fillStyle = th.platHi; g.fillRect(px, py, T, 1);
    g.fillStyle = th.platLo; if (tx & 1) g.fillRect(px + 7, py + 1, 1, 2);
    if (!n.l) { g.fillStyle = K; g.fillRect(px, py, 1, 5); g.clearRect(px, py + 4, 1, 1); }
    if (!n.r) { g.fillStyle = K; g.fillRect(px + 15, py, 1, 5); g.clearRect(px + 15, py + 4, 1, 1); }
    g.fillStyle = 'rgba(0,0,0,0.25)'; g.fillRect(px + 2, py + 5, 12, 1);
  };
  G.drawSpikes = (g, px, py, down) => {
    const C = G.COL;
    for (let s = 0; s < 4; s++) {
      const x = px + s * 4;
      for (let i = 0; i < 7; i++) {
        const y = down ? py + i : py + 15 - i;
        const wd = i < 2 ? 4 : i < 4 ? 2 : 1, ox = i < 2 ? 0 : i < 4 ? 1 : (s & 1 ? 1 : 2);
        g.fillStyle = i >= 5 ? C.hazardHi : i < 1 ? C.hazardLo : C.hazard;
        g.fillRect(x + ox, y, wd, 1);
      }
    }
  };
  // dynamic blocks get their own little sprites
  const S = G.SPR;
  S.cracked = (() => {
    const p = G.pix(16, 16);
    p.rect(0, 0, 16, 16, '#8d8798').rect(0, 0, 16, 1, '#c3bccd').rect(0, 0, 1, 16, '#c3bccd').rect(0, 15, 16, 1, '#4c4658').rect(15, 0, 1, 16, '#4c4658');
    p.line(3, 1, 6, 5, K).line(6, 5, 5, 9, K).line(5, 9, 9, 12, K).line(9, 12, 8, 15, K).line(6, 5, 11, 4, K).line(11, 4, 13, 7, K).line(5, 9, 2, 11, K);
    p.px(2, 2, '#4c4658').px(13, 13, '#c3bccd');
    return p.c;
  })();
  S.crumble = (() => {
    const p = G.pix(16, 16);
    p.rect(0, 0, 16, 9, '#cbb894').rect(0, 0, 16, 1, '#f4ead2').rect(0, 8, 16, 1, '#8a7a5c');
    for (let i = 0; i < 16; i += 4) p.rect(i + 1, 3, 2, 1, '#8a7a5c').rect(i + 3, 5, 1, 1, '#8a7a5c');
    p.rect(2, 9, 2, 2, '#8a7a5c').rect(7, 9, 3, 3, '#8a7a5c').rect(12, 9, 2, 1, '#8a7a5c').px(8, 12, '#8a7a5c');
    return p.c;
  })();
  S.blink = ['#4ec9b0', '#f29e4c'].map((col) => {
    const on = G.pix(16, 16), off = G.pix(16, 16), hi = G.mix(col, '#ffffff', 0.5), lo = G.mix(col, '#000000', 0.45);
    on.rect(0, 0, 16, 16, col).rect(0, 0, 16, 1, hi).rect(0, 0, 1, 16, hi).rect(0, 15, 16, 1, lo).rect(15, 0, 1, 16, lo).rect(4, 4, 8, 8, lo).rect(5, 5, 6, 6, hi).rect(6, 6, 4, 4, col);
    for (let i = 0; i < 16; i += 3) off.px(i, 0, lo).px(15 - i, 15, lo).px(0, 15 - i, lo).px(15, i, lo);
    off.rect(7, 7, 2, 2, lo);
    return { on: on.c, off: off.c };
  });
  G.platformSprite = (w) => {
    const key = 'plat' + w;
    if (!S[key]) {
      const th = TH[w], p = G.pix(48, 10);
      p.rect(1, 0, 46, 6, th.plat).rect(1, 0, 46, 1, th.platHi).rect(1, 5, 46, 1, th.platLo);
      p.rect(0, 1, 1, 4, th.platLo).rect(47, 1, 1, 4, th.platLo);
      p.rect(4, 2, 3, 2, th.accent).rect(41, 2, 3, 2, th.accent);
      for (let i = 12; i < 38; i += 6) p.rect(i, 2, 3, 1, th.platLo);
      p.rect(8, 6, 4, 2, th.platLo).rect(36, 6, 4, 2, th.platLo).rect(9, 8, 2, 1, th.accent).rect(37, 8, 2, 1, th.accent);
      p.outline(K);
      S[key] = p.c;
    }
    return S[key];
  };
  // liquid: body + a wobbling surface line. y is the surface in screen space.
  G.drawLiquid = (g, w, x0, y, x1, y1, t, camX) => {
    const th = TH[w];
    if (y > H) return;
    const top = Math.max(-2, Math.round(y));
    g.fillStyle = G.rgba(th.liq, 0.5); g.fillRect(x0, top + 2, x1 - x0, y1 - top);
    g.fillStyle = G.rgba(th.liqLo, 0.45); g.fillRect(x0, top + 8, x1 - x0, y1 - top - 6);
    for (let x = Math.floor(x0); x < x1; x++) {
      const wx = x + camX, o = Math.round(Math.sin(wx * 0.19 + t * 2.6) * 1.2 + Math.sin(wx * 0.07 - t * 1.7) * 1.1);
      g.fillStyle = th.liqHi; g.fillRect(x, top + o, 1, 1);
      g.fillStyle = th.liq; g.fillRect(x, top + o + 1, 1, 2);
      if (hash(wx >> 2, Math.floor(t * 3 + wx * 0.01), 3) < 0.012) { g.fillStyle = th.liqHi; g.fillRect(x, top + 5 + ((wx * 7) % 23), 1, 1); }
    }
  };

  // ---------- backdrops ----------
  const BG = {};
  function strip(w, h, fn, seed) { const p = G.pix(w, h); fn(p, G.rng(seed)); return p.c; }
  function dirTree(p, x, baseY, height, col, leaf, r) {
    p.rect(x, baseY - height, 2, height, col);
    let y = baseY - 12, side = r() < 0.5 ? 1 : -1;
    while (y > baseY - height + 8) {
      const len = 5 + Math.floor(r() * 12);
      p.rect(side > 0 ? x + 2 : x - len, y, len, 1, col);
      const lx = side > 0 ? x + 2 + len : x - len - 8;
      p.rect(lx, y - 3, 8, 6, leaf).rect(lx + 1, y - 4, 6, 8, leaf);
      if (r() < 0.6) { const tx = side > 0 ? x + 2 + (len >> 1) : x - (len >> 1); p.rect(tx, y, 1, 5, col).rect(tx - 2, y + 4, 5, 4, leaf); }
      y -= 9 + Math.floor(r() * 9); side = -side;
    }
    p.rect(x - 5, baseY - height - 6, 12, 8, leaf).rect(x - 3, baseY - height - 8, 8, 12, leaf);
  }
  function bigGear(R, teeth, col, lo) {
    const frames = [], N = R * 2 + 6, c = N / 2;
    for (let k = 0; k < 10; k++) {
      const rot = (k / 10) * ((Math.PI * 2) / teeth), p = G.pix(N, N);
      p.shape((x, y) => { const dx = x - c, dy = y - c, d = Math.hypot(dx, dy), a = Math.atan2(dy, dx) + rot; return d < (Math.cos(a * teeth) > 0 ? R : R - R * 0.16) && d > R * 0.3 && !(d < R * 0.7 && d > R * 0.42 && Math.cos((a) * 5) > 0.35); }, col);
      p.shape((x, y) => { const d = Math.hypot(x - c, y - c); return d < R * 0.3 && d > R * 0.12; }, lo);
      frames.push(p.c);
    }
    return frames;
  }
  const build = {
    1() {
      const sky = G.ditherGrad(W, H, [[0, '#0b1222'], [0.4, '#102236'], [0.72, '#19404e'], [1, '#27665c']]);
      const far = strip(512, 216, (p, r) => { for (let x = 20; x < 512; x += 44 + Math.floor(r() * 40)) dirTree(p, x, 216, 70 + Math.floor(r() * 70), '#10283a', '#143042', r); }, 11);
      const mid = strip(512, 216, (p, r) => { for (let x = 10; x < 512; x += 70 + Math.floor(r() * 50)) dirTree(p, x, 216, 110 + Math.floor(r() * 80), '#143540', '#1b4a4a', r); }, 12);
      const near = strip(512, 216, (p, r) => {
        for (let x = 0; x < 512; x++) { const h = 26 + Math.sin(x * 0.0245) * 10 + Math.sin(x * 0.0736 + 2) * 5 + Math.sin(x * 0.184) * 2; p.rect(x, 216 - h, 1, h, '#18413f'); if (r() < 0.25) p.rect(x, 216 - h - 1 - Math.floor(r() * 3), 1, 3, '#18413f'); }
        for (let x = 30; x < 512; x += 90 + Math.floor(r() * 60)) { p.ell(x, 196, 14, 9, '#1d4d47'); p.ell(x + 12, 199, 10, 7, '#1d4d47'); }
      }, 13);
      const stars = []; const r = G.rng(5);
      for (let i = 0; i < 70; i++) stars.push({ x: Math.floor(r() * W), y: Math.floor(r() * 120), p: r() * 6.28, b: r() });
      const flies = []; for (let i = 0; i < 16; i++) flies.push({ x: r() * 512, y: 60 + r() * 130, p: r() * 6.28, s: 0.4 + r() * 0.8 });
      return {
        sky, layers: [{ img: far, fx: 0.12, fy: 0.05 }, { img: mid, fx: 0.28, fy: 0.12 }, { img: near, fx: 0.5, fy: 0.25 }],
        pre(g, cx, cy, t) {
          for (const s of stars) { const a = 0.35 + 0.65 * Math.abs(Math.sin(t * (0.6 + s.b) + s.p)); g.fillStyle = s.b > 0.85 ? G.rgba('#ffe9a8', a) : G.rgba('#cfe0ff', a * 0.8); g.fillRect(s.x, s.y, 1, 1); }
          const mx = 292 - cx * 0.02, my = 46;
          G.disc(g, mx, my, 19, '#f3e7c2'); G.disc(g, mx - 6, my - 5, 4, '#e2d3a6'); G.disc(g, mx + 7, my + 6, 3, '#e2d3a6'); G.disc(g, mx + 5, my - 9, 2, '#e2d3a6');
          G.light(mx, my, 70, '#f3e7c2', 0.9, 0.28);
        },
        post(g, cx, cy, t) {
          for (const f of flies) {
            const x = ((f.x + Math.sin(t * f.s + f.p) * 22 - cx * 0.7) % 512 + 512) % 512 - 60, y = f.y + Math.cos(t * f.s * 1.3 + f.p) * 14;
            const a = 0.5 + 0.5 * Math.sin(t * 2 * f.s + f.p * 3);
            if (a > 0.2 && x < W + 4) { g.fillStyle = G.rgba('#ffe9a8', a); g.fillRect(Math.round(x), Math.round(y), 1, 1); G.light(x, y, 16, '#ffd97a', 0.5 * a, 0.3 * a); }
          }
        },
      };
    },
    2() {
      const sky = G.ditherGrad(W, H, [[0, '#120a14'], [0.5, '#24121d'], [1, '#3a1d27']]);
      const stack = (p, r, c1, c2, c3, step, maxN) => {
        for (let x = -6; x < 512; x += step + Math.floor(r() * step * 0.5)) {
          let y = 216; const n = 1 + Math.floor(r() * maxN);
          for (let i = 0; i < n; i++) {
            const w = step * 0.7 + r() * step * 0.5, h = step * 0.5 + r() * step * 0.45, ox = x + r() * 8 - 4;
            y -= h;
            p.rect(ox, y, w, h, c1).rect(ox, y, w, 1, c2).rect(ox, y, 1, h, c2).rect(ox + w * 0.42, y + 1, w * 0.14, h - 1, c3);
            if (r() < 0.4) p.rect(ox + w * 0.65, y + h * 0.55, w * 0.22, h * 0.25, c3);
          }
        }
      };
      const far = strip(512, 216, (p, r) => stack(p, r, '#22131c', '#2c1823', '#2c1823', 22, 7), 21);
      const lamps = [];
      const mid = strip(512, 216, (p, r) => {
        stack(p, r, '#33202a', '#452a35', '#3d2530', 34, 4);
        for (let x = 40; x < 512; x += 120) {      // cables + lamps
          const sag = 30 + r() * 20;
          for (let i = 0; i <= 120; i++) { const u = i / 120; p.px(x + i, 4 + Math.sin(u * Math.PI) * sag, '#1a0f16'); }
          const lx = x + 60, ly = 4 + sag;
          p.rect(lx - 1, ly, 2, 4, '#1a0f16').rect(lx - 3, ly + 4, 6, 3, '#5a3a2a').rect(lx - 2, ly + 7, 4, 1, '#ffd9a0');
          lamps.push({ x: lx, y: ly + 8 });
        }
      }, 22);
      const near = strip(512, 216, (p, r) => stack(p, r, '#472a33', '#5a3640', '#52303a', 48, 1), 23);
      const motes = []; const r = G.rng(8); for (let i = 0; i < 26; i++) motes.push({ x: r() * W, y: r() * H, s: 0.2 + r() * 0.6, p: r() * 6.28 });
      return {
        sky, layers: [{ img: far, fx: 0.12, fy: 0.06 }, { img: mid, fx: 0.3, fy: 0.14, lamps }, { img: near, fx: 0.52, fy: 0.3 }],
        post(g, cx, cy, t) {
          for (const m of motes) { const x = ((m.x - cx * 0.4 + Math.sin(t * m.s + m.p) * 8) % W + W) % W, y = (m.y + t * 4 * m.s) % H; g.fillStyle = 'rgba(255,220,180,0.25)'; g.fillRect(Math.round(x), Math.round(y), 1, 1); }
        },
      };
    },
    3() {
      const sky = G.ditherGrad(W, H, [[0, '#04061a'], [0.55, '#0a1232'], [1, '#12244f']]);
      const far = strip(512, 256, (p, r) => {
        for (let i = 0; i < 26; i++) G.text(p.g, '0x' + Math.floor(r() * 65535).toString(16).toUpperCase().padStart(4, '0'), Math.floor(r() * 480), Math.floor(r() * 250), '#0f1a44', { tiny: true });
        for (let x = 0; x < 512; x += 18 + Math.floor(r() * 30)) { const w = 6 + Math.floor(r() * 16), h = 20 + Math.floor(r() * 60); for (let i = 0; i < h; i++) { const ww = Math.max(1, Math.round(w * (1 - i / h))); p.rect(x + (w - ww) / 2, i, ww, 1, '#0a1436'); } }
      }, 31);
      const mid = strip(512, 256, (p, r) => {
        for (let x = 10; x < 512; x += 46 + Math.floor(r() * 50)) {
          const w = 8 + Math.floor(r() * 10), y0 = Math.floor(r() * 200), h = 50 + Math.floor(r() * 90);
          for (let i = 0; i < h; i++) { const u = i / h, ww = Math.max(1, Math.round(w * Math.sin(u * Math.PI) ** 0.6)); p.rect(x + (w - ww) / 2, (y0 + i) % 256, ww, 1, '#11225c'); p.px(x + (w - ww) / 2, (y0 + i) % 256, '#1b3a8a'); }
          if (r() < 0.7) p.px(x + w / 2, (y0 + h * 0.3) % 256, '#58f0c8');
        }
      }, 32);
      const near = strip(512, 216, (p, r) => { for (let x = 0; x < 512; x++) { const h = 18 + Math.abs(Math.sin(x * 0.037)) * 22 + Math.abs(Math.sin(x * 0.11 + 1)) * 8; p.rect(x, 216 - h, 1, h, '#14306e'); } for (let x = 20; x < 512; x += 60 + Math.floor(r() * 50)) { const h = 20 + Math.floor(r() * 26); for (let i = 0; i < h; i++) p.rect(x - (h - i) / 5, 200 - i, Math.max(1, ((h - i) / 5) * 2), 1, '#1a3c86'); } }, 33);
      const motes = []; const r = G.rng(9); for (let i = 0; i < 22; i++) motes.push({ x: r() * W, y: r() * H, s: 0.3 + r() * 0.8, p: r() * 6.28 });
      return {
        sky, layers: [{ img: far, fx: 0.1, fy: 0.08, tileY: 1 }, { img: mid, fx: 0.26, fy: 0.2, tileY: 1 }, { img: near, fx: 0.5, fy: 0.3 }],
        post(g, cx, cy, t) {
          for (const m of motes) { const x = ((m.x - cx * 0.5 + Math.sin(t * m.s + m.p) * 6) % W + W) % W, y = H - ((m.y + t * 9 * m.s) % H); g.fillStyle = 'rgba(124,245,212,0.5)'; g.fillRect(Math.round(x), Math.round(y), 1, 1); if (m.s > 0.8) G.light(x, y, 12, '#58f0c8', 0.35, 0.2); }
        },
      };
    },
    4() {
      const sky = G.ditherGrad(W, H, [[0, '#231531'], [0.3, '#4f2750'], [0.56, '#a8465c'], [0.78, '#ea8552'], [1, '#f7c873']]);
      const far = strip(512, 216, (p, r) => {
        for (let x = 0; x < 512; x += 50 + Math.floor(r() * 50)) {
          const w = 18 + Math.floor(r() * 16), h = 70 + Math.floor(r() * 90);
          p.rect(x, 216 - h, w, h, '#3d2148');
          for (let i = 0; i < w / 2; i++) p.rect(x + i, 216 - h - i - 1, w - i * 2, 1, '#3d2148');
          G.disc(p.g, x + w / 2, 216 - h + 12, 5, '#f3d58a'); p.rect(x + w / 2, 216 - h + 8, 1, 4, '#3d2148').rect(x + w / 2, 216 - h + 12, 3, 1, '#3d2148');
          for (let y = 216 - h + 26; y < 210; y += 12) if (r() < 0.6) p.rect(x + 4 + Math.floor(r() * (w - 9)), y, 2, 3, '#f7c873');
        }
      }, 41);
      const gA = bigGear(46, 14, '#522a56', '#3a1c40'), gB = bigGear(28, 9, '#5e3160', '#3a1c40'), gC = bigGear(18, 7, '#6b3a66', '#3a1c40');
      const gears = []; const r = G.rng(44);
      for (let i = 0; i < 9; i++) gears.push({ x: i * 86 + r() * 30, y: r() * 300, set: [gA, gB, gC][i % 3], sp: (i % 2 ? 1 : -1) * (2 + (i % 3) * 2), ph: r() * 10 });
      const near = strip(512, 216, (p, r2) => {
        for (let x = 0; x < 512; x += 64) { p.rect(x, 170, 3, 46, '#2a1430'); for (let i = 0; i < 46; i++) { p.px(x + 3 + (i * 61) / 46, 170 + i, '#2a1430'); p.px(x + 64 - (i * 61) / 46, 170 + i, '#2a1430'); } }
        p.rect(0, 170, 512, 2, '#2a1430').rect(0, 212, 512, 4, '#2a1430');
        void r2;
      }, 43);
      return {
        sky, layers: [{ img: far, fx: 0.1, fy: 0.04 }, { gears, fx: 0.24, fy: 0.16 }, { img: near, fx: 0.48, fy: 0.3 }],
        pre(g, cx) {
          const sx = 250 - cx * 0.015;
          G.disc(g, sx, 168, 34, '#ffe9a8'); G.light(sx, 168, 120, '#ffc27a', 0.6, 0.3);
          g.fillStyle = '#ea8552'; for (let i = 0; i < 5; i++) g.fillRect(40 + i * 70 - ((cx * 0.03) % 70), 150 + (i % 3) * 9, 46 + (i % 2) * 20, 2);
        },
      };
    },
    5() {
      const sky = G.ditherGrad(W, H, [[0, '#08080d'], [0.5, '#190c12'], [1, '#3d1310']]);
      const racks = (p, r, c1, c2, wU, led) => {
        for (let x = 0; x < 512; x += wU + 6) {
          const h = 110 + Math.floor(r() * 90);
          p.rect(x, 216 - h, wU, h, c1).rect(x, 216 - h, wU, 1, c2).rect(x, 216 - h, 1, h, c2);
          for (let y = 216 - h + 5; y < 212; y += 7) { p.rect(x + 2, y, wU - 4, 1, c2); if (led && r() < 0.5) p.px(x + 3 + Math.floor(r() * (wU - 7)), y + 2, r() < 0.3 ? '#7a1c18' : r() < 0.5 ? '#6a5a1c' : '#1c5a34'); }
        }
      };
      const far = strip(512, 216, (p, r) => racks(p, r, '#12121a', '#1a1a24', 20, 1), 51);
      const mid = strip(512, 216, (p, r) => {
        racks(p, r, '#191922', '#252532', 34, 1);
        for (let x = 30; x < 512; x += 90) for (let i = 0; i <= 80; i++) p.px(x + i, 8 + Math.sin((i / 80) * Math.PI) * (16 + (x % 3) * 8), '#0c0c12');
      }, 52);
      const embers = []; const r = G.rng(10); for (let i = 0; i < 34; i++) embers.push({ x: r() * W, y: r() * H, s: 0.4 + r(), p: r() * 6.28 });
      return {
        sky, layers: [{ img: far, fx: 0.12, fy: 0.05 }, { img: mid, fx: 0.3, fy: 0.12, blink: 1 }],
        pre(g, cx, cy, t) {
          const a = 0.5 + 0.5 * Math.sin(t * 3.2);
          G.light(60 - ((cx * 0.3) % 400) + 200, 30, 120, '#ff4b3e', 0.25 * a, 0.22 * a);
          G.light(W / 2, H + 30, 200, '#ff6a2a', 0.5, 0.2);
        },
        post(g, cx, cy, t) {
          for (const e of embers) { const y = H - ((e.y + t * 26 * e.s) % (H + 10)), x = ((e.x - cx * 0.6 + Math.sin(t * 1.4 * e.s + e.p) * 10) % W + W) % W; g.fillStyle = e.s > 0.9 ? '#ffd23f' : '#ff7a2f'; g.fillRect(Math.round(x), Math.round(y), 1, 1); if (e.s > 1.1) G.light(x, y, 9, '#ff7a2f', 0.3, 0.25); }
        },
      };
    },
    // the town: the Source Tree's sky, moon and fireflies over hills of little houses
    town() {
      const b = BG[1] || (BG[1] = build[1]());
      const house = (p, r, x, base, w, h, col, win, lit) => {
        p.rect(x, base - h, w, h + 40, col);
        const rh = Math.ceil(w / 2);
        for (let i = 0; i < rh; i++) p.rect(x - 1 + i, base - h - i - 1, w + 2 - i * 2, 1, col);
        if (r() < 0.5) p.rect(x + w - 5, base - h - rh + 1, 3, rh - 2, col);
        for (let wy = base - h + 4; wy < base - 3; wy += 7) for (let wx = x + 3; wx < x + w - 3; wx += 6) if (r() < lit) p.rect(wx, wy, 2, 3, win);
      };
      const hill = (x) => 58 + Math.sin(x * 0.0123) * 14 + Math.sin(x * 0.0491 + 1) * 5;
      const far = strip(512, 216, (p, r) => {
        for (let x = 0; x < 512; x++) p.rect(x, 216 - hill(x), 1, hill(x), '#0f2232');
        for (let x = 6; x < 512; x += 20 + Math.floor(r() * 28)) house(p, r, x, 216 - hill(x) + 4, 8 + Math.floor(r() * 7), 6 + Math.floor(r() * 7), '#0f2232', '#b88a50', 0.35);
      }, 61);
      const mid = strip(512, 216, (p, r) => {
        for (let x = -6; x < 512; x += 28 + Math.floor(r() * 30)) {
          if (r() < 0.3) { p.rect(x + 8, 216 - 70, 2, 70, '#13303c'); p.ell(x + 9, 216 - 78, 13, 15, '#13303c'); continue; }
          house(p, r, x, 216 - 30, 18 + Math.floor(r() * 14), 22 + Math.floor(r() * 34), '#13303c', '#d8a858', 0.3);
        }
      }, 62);
      const near = strip(512, 216, (p, r) => {
        for (let x = 0; x < 512; x++) { const h = 40 + Math.sin(x * 0.031) * 6 + Math.sin(x * 0.09 + 2) * 3; p.rect(x, 216 - h, 1, h, '#163a3e'); if (r() < 0.2) p.rect(x, 216 - h - 1 - Math.floor(r() * 2), 1, 2, '#163a3e'); }
        for (let x = 20; x < 512; x += 70 + Math.floor(r() * 50)) { p.ell(x, 172, 13, 9, '#1a4644'); p.ell(x + 11, 175, 9, 7, '#1a4644'); }
      }, 63);
      return { sky: b.sky, layers: [{ img: far, fx: 0.08, fy: 0.04 }, { img: mid, fx: 0.2, fy: 0.1 }, { img: near, fx: 0.4, fy: 0.2 }], pre: b.pre, post: b.post };
    },
  };
  // cx, cy: camera. bottom: camera y when looking at the lowest part of the level
  G.drawBG = (w, g, cx, cy, t, bottom) => {
    const b = BG[w] || (BG[w] = build[w]());
    g.drawImage(b.sky, 0, 0);
    if (b.pre) b.pre(g, cx, cy, t);
    const rise = Math.max(0, (bottom || 0) - cy);
    for (const L of b.layers) {
      const dy = Math.round(rise * L.fy);
      if (L.gears) {
        for (const q of L.gears) {
          const x = ((q.x - cx * L.fx) % 780 + 780) % 780 - 110, y = ((q.y + dy) % 420 + 420) % 420 - 100;
          const fr = q.set[((Math.floor(t * q.sp + q.ph) % 10) + 10) % 10];
          if (x < W && y < H) g.drawImage(fr, Math.round(x), Math.round(y));
        }
        continue;
      }
      const iw = L.img.width, ih = L.img.height;
      const x = -(((cx * L.fx) % iw + iw) % iw);
      if (L.tileY) {
        const y0 = (dy % ih + ih) % ih - ih;
        for (let y = y0; y < H; y += ih) { g.drawImage(L.img, Math.round(x), y); if (x + iw < W) g.drawImage(L.img, Math.round(x) + iw, y); }
      } else {
        const y = H - ih + dy;
        if (y < H) { g.drawImage(L.img, Math.round(x), y); if (x + iw < W) g.drawImage(L.img, Math.round(x) + iw, y); }
      }
      if (L.lamps) for (const l of L.lamps) { const lx = ((l.x + x) % iw + iw) % iw; if (lx < W + 40) G.light(lx, l.y + H - ih + dy, 60, '#ffc27a', 0.75, 0.22); }
    }
    if (b.post) b.post(g, cx, cy, t);
  };
})();

